import { Validator } from '@vista-digital/validator';
import { runInAction } from 'mobx';
import { configurationSettings } from '../../../../configuration/configuration-settings';
import { TicketingMode } from '../../../../configuration/types/order/ticketing-mode';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { ticketDetailsValidator } from '../../../../utils/validators/ticket-details';
import { mapTicketDetailsToOrderTicketLine } from '../../mappers/order-ticket-line';
import { getOrderSeatsForShowtime } from '../../selectors/seats/get-order-seats-for-showtime';
import { getOrderTicketsForShowtime } from '../../selectors/tickets/get-order-tickets-for-showtime';
import { orderDomainStore } from '../../store';
import { canTicketBeAddedToOrder } from '../../utils/tickets/can-ticket-be-added-to-order';
const quantityValidator = Validator.number({ min: 0 });
/**
 * Adds a ticket to the order.
 */
export const addOrderTicketForShowtime = (showtimeId, ticket, quantity = 1) => {
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot add ticket. Provided showtimeId is invalid.');
    }
    if (!ticketDetailsValidator(ticket, logger.error, 'ticket')) {
        throw new Error('Cannot add ticket. Provided ticket details are invalid.');
    }
    if (!quantityValidator(quantity, logger.error, 'quantity')) {
        throw new Error('Cannot add ticket. Provided quantity is invalid.');
    }
    if (!canTicketBeAddedToOrder(showtimeId, ticket.ticketTypeId, quantity)) {
        throw new Error('Cannot add ticket. Requested quantity exceeds order limits.');
    }
    const tickets = getOrderTicketsForShowtime(showtimeId);
    const newTickets = [...Array(quantity)].map(() => mapTicketDetailsToOrderTicketLine(ticket));
    const { ticketingMode } = configurationSettings.data.order;
    const isSeatFirstOrdering = ticketingMode === TicketingMode.SeatFirst;
    runInAction(() => {
        orderDomainStore.data.selections.showtime = {
            showtimeId,
            tickets: [...tickets, ...newTickets],
            seats: isSeatFirstOrdering ? getOrderSeatsForShowtime(showtimeId) : []
        };
    });
};
